import request from 'superagent';

import * as symbolActions from '../../editor/actions/symbolActions';

const team = window.team ? window.team.url : null;
const teamId = window.team ? window.team.id : null;

const apiActions = {
  getSymbol: symbolId => () =>
    new Promise((resolve, reject) => {
      request
        .get(`/symbols?id=${symbolId}`)
        .set('Accept', 'application/json')
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve(response.body);
          }
        });
    }),

  getColors: () => () =>
    new Promise((resolve, reject) => {
      const url = teamId ? `/colors?team=${teamId}` : '/colors';

      request
        .get(url)
        .set('Accept', 'application/json')
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve(response.body);
          }
        });
    }),

  saveColor: value => () =>
    new Promise((resolve, reject) => {
      const payload = { value, team };

      request
        .post('/colors')
        .set('Accept', 'application/json')
        .send(payload)
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve();
          }
        });
    }),

  deleteColor: id => () =>
    new Promise((resolve, reject) => {
      request
        .delete(`/colors?id=${id}`)
        .set('Accept', 'application/json')
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve();
          }
        });
    }),

  saveFile: (remoteUrl, service, mimeType, size) => () =>
    new Promise((resolve, reject) => {
      request
        .post('/files/save')
        .set('Accept', 'application/json')
        .send({
          remote_url: remoteUrl,
          service,
          mime_type: mimeType,
          size,
          team,
        })
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve(response.text);
          }
        });
    }),

  saveFont: (name, original, webfont) => () =>
    new Promise((resolve, reject) => {
      request
        .post('/fonts/save')
        .set('Accept', 'application/json')
        .send({
          name,
          original,
          webfont,
          team,
        })
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve(response.text);
          }
        });
    }),

  saveGoogleFont: (name, variants) => () =>
    new Promise((resolve, reject) => {
      request
        .post('/fonts/save-google')
        .set('Accept', 'application/json')
        .send({ name, variants, team })
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            resolve(response.text);
          }
        });
    }),

  deleteSymbol: symbolId => dispatch =>
    new Promise((resolve, reject) => {
      request
        .delete(`/symbols?id=${symbolId}`)
        .set('Accept', 'application/json')
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else {
            dispatch(symbolActions.unregisterSymbol(symbolId));
            resolve();
          }
        });
    }),

  canBeLoadedInsideAnIframe: url => () =>
    new Promise((resolve, reject) => {
      request
        .get(`/can-be-loaded-inside-an-iframe?url=${url}`)
        .end((error, response) => {
          if (error || !response.ok) {
            reject(error || 'UNKNOWN ERROR');
          } else if (response.text === 'NO') {
            reject();
          } else {
            resolve();
          }
        });
    }),

  healthCheck: resource => () =>
    new Promise(resolve => {
      request
        .post('/tools/health-check')
        .set('Accept', 'application/json')
        .send({ resource })
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.error(error);
          resolve();
        });
    }),
};

export default apiActions;
